import React, { useState, useEffect } from 'react'
import {Route, Routes } from 'react-router-dom'
import Nav from '../components/Nav'
import Dashboard from './Dashboard'
import TicketPage from './TicketPage'
import CategoriesContext from '../context'
import alanBtn from "@alan-ai/alan-sdk-web";
import useStateReference from './useStateReference';
import { useNavigate } from 'react-router-dom'

function App() {
  const [categories, setCategories] = useState(null)
  const value = { categories, setCategories }
  const navigate = useNavigate();

  const [tickets, setTickets] = useState(null);
  
  const [count] = useStateReference({});

  useEffect(() => {
    alanBtn({
      key: process.env.REACT_APP_ALAN_KEY,
      onCommand: (commandData) => {
        console.info('Actual count value:', count.current);
        console.log(commandData, count.current);
        if (commandData.command === 'goBack') {
            navigate(-1);
          }
        if (commandData.command === 'goForward') {
            navigate(1);
          }
        if (commandData.command === 'newTicket') {
            navigate('/ticket');
          }
        if (commandData.command === 'goHome') {
            navigate('/');
          }
      }
    });
  }, []);


  return (
    <CategoriesContext.Provider value={value}>
    <div className="app">
          <Nav />
          <Routes>
            <Route path="/" element={<Dashboard tickets={tickets} setTickets={setTickets}/>} />
            <Route path="/ticket" element={<TicketPage />} />
            <Route path="/ticket/:id" element={<TicketPage editMode={true} />} />
          </Routes>
        </div>
      </CategoriesContext.Provider>
  )
}

export default App
